'use strict';

import Vue from 'vue/dist/vue.common.js';

// components
import SignupForm from '../components/signup-form';
// vuex
import store from '../vuex/store';

let Signup = Vue.extend({
  store,
  components: {
    SignupForm
  },
  // beforeCreate() {
  //   if ( !!this.$store.state.loggedIn ) {
  //     window.location = "/";
  //   }
  // },
});

export default Signup;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/signup.js